const PersonFollow = () => import('@/modules/fwscperson/personFollowGoods/personFollow')
const PersonOrder = () => import('@/modules/fwscperson/personOrderManager/personOrder')
const PersonEvaluation = () => import('@/modules/fwscperson/personEvaluation/personEvaluation')
const PersonFootprint = () => import('@/modules/fwscperson/personFootprint/personFootprint')
const PersonCompact = () => import('@/modules/fwscperson/personCompactManager/PersonCompactList')
const PersonFollowMart = () => import('@/modules/fwscperson/personFollowMart/PersonFollowMart')
const PersonBank = () => import('@/modules/fwscperson/bankInfo/PersonBank')
const PageLegaldemand = () => import('@/modules/fwscperson/legaldemand/PageLegaldemand')
const PersonWallet = () => import('@/modules/fwscperson/personwallet/PersonWallet')
export default [
  {

    path: '/fwscperson/perosonFollow',
    name: 'fwscWdgz',
    component: PersonFollow,
    meta: {
      title: '关注商品',
      isBlack: true
    },
  },
  {

    path: '/fwscperson/followMart',
    name: 'fwscGzdp',
    component: PersonFollowMart,
    meta: {
      title: '关注店铺',
      isBlack: true
    },
  },
  {

    path: '/fwscperson/perosonOrder',
    name: 'fwscWddd',
    component: PersonOrder,
    meta: {
      title: '我的订单',
      isBlack: true
    },
  },
  {

    path: '/fwscperson/perosonCompact',
    name: 'fwscWdht',
    component: PersonCompact,
    meta: {
      title: '我的合同',
      isBlack: true
    },
  },
  {

    path: '/fwscperson/perosonEvaluation',
    name: 'fwscWdpj',
    component: PersonEvaluation,
    meta: {
      title: '我的评价',
      isBlack: true
    },
  },
  {

    path: '/fwscperson/perosonFootprint',
    name: 'fwscWdzj',
    component: PersonFootprint,
    meta: {
      title: '我的足迹',
      isBlack: true
    },
  },
  {

    path: '/bankinfo',
    name: 'bankinfo',
    component: PersonBank,
    meta: {
      title: '我的银行卡',
      isBlack: true
    },
  },
  {

    path: '/fwscperson/legaldemand',
    name: 'legaldemand',
    component: PageLegaldemand,
    meta: {
      title: '法律需求',
      isBlack: true
    },
  },
  {

    path: '/fwscperson/wallet',
    name: 'personwallet',
    component: PersonWallet,
    meta: {
      title: '钱包明细',
    },
  },
]
